import initJumpLinks from './components/jump-links';
import initClientLists from './components/client-list';

const jumpLinks = document.querySelector('.js-jump-links');

if (jumpLinks) {
    initJumpLinks(jumpLinks);
}

const clientLists = document.querySelectorAll('.js-clients');

if (clientLists && clientLists.length > 0) {
    initClientLists(clientLists);
}